import React, { useCallback, useEffect, useMemo, useState } from 'react';

// import '@ant-design/compatible/assets/index.css';


import {
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  InputNumber,
  //   Radio,
  Row,
  Select,
  Spin,
  Tag,
  message,
} from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import { FormInstance } from 'antd/lib/form/Form';
import {
  FinAssetResponse,
  getFinContractById,
  getFinModificationByModid,
  getFinModificationValidByCtrid,
} from 'services/fincontract';
import { useQuery } from 'react-query';
import UtinaCard from 'components/UtinaCard';
import Value from 'components/Value';
import { dateToString, indexBy, toDatePickerDate } from 'utils/utils2';
import ParListSelect from 'components/ParListSelect';
import TextArea from 'antd/lib/input/TextArea';
import InputCurrency from 'components/InputCurrency';
import _, { isNil, sumBy } from 'lodash';
import moment from 'moment';
import PricingListFilteredSelect from 'components/PricingListFilteredSelect';
import InputRate from 'components/InputRate';
import RateFormulaSelect from 'components/RateFormulaSelect';
import {
  AssetRVCriteria,
  AssetUseCriteria,
  FilteringCriteria,
  PricingResponse,
  getprOfferDetailByOfferId,
  prFilteringCriteria,
} from 'services/pricing';
import * as finEngine from 'services/finEngine';
import { toCurrency, toRate } from 'utils/utils';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import getEnvValue from 'utils/getEnvValue';
import OfferInput from 'pages/ProposalV3/PropDetail/OfferInput';

export type TabColCommentProps = {
  form: FormInstance;
  objectid: number;
  object: string;
};

const TabLoanRescheduling = ({
  objectid,
  object,
  form,
}: TabColCommentProps) => {
  const [mode, setMode] = useState('SIMUL');
  const [isLoading, setIsLoading] = useState(false);

  let [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [selectedClass, setSelectedClass] = useState<string>('');

  const fieldname = 'assets';

  const { data: modList } = useQuery(
    ['getFinModificationValidByCtrid', { ctrid: objectid }],
    () =>
      getFinModificationValidByCtrid({
        ctrid: objectid,
        modevent: 'PREFINRENE',
      }).then((res) => res.list),
    { refetchOnMount: true }
  );

  const { data: contract, isFetching } = useQuery(
    ['getFinContractById', objectid],
    () => getFinContractById({ ctrid: objectid }).then((res) => res.data),
    {
      refetchOnWindowFocus: false,
    }
  );

  const handleFinModSelect = (finmod: number) => {
    if (finmod === undefined) {
      //   updateState({ isModSelected: false });
      return;
    }

    let query = getFinModificationByModid({ modid: finmod });
    setIsLoading(true);
    query
      .then((response) => {
        setIsLoading(false);

        if (response.code !== '200') {
          return;
        }
        const res = response.data;

        let elemList = res.simulParams
          .find((item) => item.parcode === 'ELEMENTS' && item.partype === 'IN')
          ?.finModSimulParamElements.map((e) => {
            return {
              ...e,
              payOffAmount: e?.outstandingamount - e?.newoutstandingamount,
            };
          });
        let effectDate = res?.simulParams?.find(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )?.newvalue;

        let flagamortizevat =
          res.simulParams.find(
            (item) => item.parcode === 'TAXAMORT' && item.partype === 'IN'
          )?.newvalue === 'true'
            ? true
            : false;

        form?.setFieldsValue({
          mode: 'REAL',
          effectDate: toDatePickerDate(effectDate),

          newEndDate: res.simulParams.find(
            (item) => item.parcode === 'ENDDATE' && item.partype === 'IN'
          )?.newvalue,
          newDuration: res.simulParams.find(
            (item) => item.parcode === 'DURATION' && item.partype === 'IN'
          )?.newvalue,

          newNominalRate: res.simulParams.find(
            (item) => item.parcode === 'NEWRATE' && item.partype === 'IN'
          )?.newvalue,

          newRateRef: res.simulParams.find(
            (item) => item.parcode === 'NEWRATEREF' && item.partype === 'IN'
          )?.newvalue,

          newRateSpread: res.simulParams.find(
            (item) => item.parcode === 'NEWRATESP' && item.partype === 'IN'
          )?.newvalue,

          newPeriodicity: res.simulParams.find(
            (item) => item.parcode === 'PERIOD' && item.partype === 'IN'
          )?.newvalue,

          newCtFinancedAmount: Number(
            res.simulParams.find(
              (item) => item.parcode === 'FINAMOUNT' && item.partype === 'IN'
            )?.newvalue
          ),

          comment: response.data.modcomment,

          feesFormula: Number(
            res.simulParams.find(
              (item) => item.parcode === 'FEESFORM' && item.partype === 'IN'
            )?.newvalue
          ),
          feesAmount: res.simulParams.find(
            (item) => item.parcode === 'FEESAMNT' && item.partype === 'IN'
          )?.newvalue,

          modreason: res.simulParams.find(
            (item) => item.parcode === 'MODREASON' && item.partype === 'IN'
          )?.newvalue,

          flagamortizevat: flagamortizevat,

          newPartDays: Number(
            res.simulParams.find(
              (item) => item.parcode === 'PARTDAYS' && item.partype === 'IN'
            )?.newvalue
          ),
        });

        let assets = form.getFieldValue('assets');
        let netamount = sumBy(assets, 'assetnetamount');
        let grossamount = sumBy(assets, 'assetfinamount');

        form.setFieldValue('flagamortizevat', flagamortizevat);

        if (flagamortizevat) {
          form.setFieldValue('assettaxamount', grossamount - netamount);
          form.setFieldValue('newCtFinancedAmount', netamount);
        }

        let _assets: any[] =
          res.simulParams.find(
            (item) => item.parcode === 'ASSETS' && item.partype === 'IN'
          )?.finModSimulParamAssets ?? [];

        let assetclass = _assets.length > 0 ? _assets[0]?.targetclass : '';

        setSelectedClass(assetclass);

        const listOfAssets = form.getFieldValue('assets');
        listOfAssets[0].assetclass = assetclass;

        form.setFieldValue('assets', listOfAssets);

        let selectElem: any = elemList
          ?.filter((el) => el.flagpayoff)
          .map((e) => e.cteid);

        setSelectedRowKeys(selectElem);
        /* handleEffectDateChange(
        res.simulParams.filter(
          (item) => item.parcode === 'EFFECTDATE' && item.partype === 'IN'
        )[0].newvalue
      );*/
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const disableDaysBeforeToday = useCallback(
    (d) => {
      if (d == null) {
        return null;
      }

      let lastInvoiceDate = form?.getFieldValue('lastInvoiceDate');
      if (lastInvoiceDate === null || lastInvoiceDate === '') {
        lastInvoiceDate = form?.getFieldValue('ctactivationdate');
      }
      return (
        moment(lastInvoiceDate) != null &&
        d.isBefore(moment(lastInvoiceDate)) &&
        !d.isSame(moment(lastInvoiceDate), 'day')
      );
    },
    [form?.getFieldValue('lastInvoiceDate')]
  );

  const getFilterList = (): prFilteringCriteria => {
    let assetList = form?.getFieldValue('assets');

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let assetRVCriteriaList: Array<AssetRVCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = [];
    let ret: prFilteringCriteria;

    offerCriteriaList.push({
      critcode: 'PROPORIGIN',
      critvalue: form?.getFieldValue('ctproporigin') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'DEALRATING',
      critvalue: form?.getFieldValue('ctdealerrating') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: form?.getFieldValue('offerid') ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'NASSETS',
      critvalue: form?.getFieldValue('assets')?.length ?? '0',
    });

    const duration = form
      ?.getFieldValue(['elements', 'FIN'])
      ?.filter(
        (e: any) => e.cteid === form?.getFieldValue('selectedElement')
      )[0]?.cteduration;

    offerCriteriaList.push({
      critcode: 'DURATION',
      critvalue: duration ?? 48,
    });

    const invest = sumBy(form?.getFieldValue('assets'), 'assetnetamount');

    offerCriteriaList.push({
      critcode: 'INVEST',
      critvalue: String(invest) ?? '0',
    });

    //PROPORIGIN

    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: contract?.prcode ?? '',
    });
    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form.getFieldValue('client')?.tpsalestatus ?? '',
    });

    assetList?.forEach((a: any) => {
      assetRVCriteriaList.push({
        catalogid: a.catalogid,
        assetid: a.assetid,
        assetsegment: a.assetsegment,
        assetfamily: a.assetfamily,
        assettype: a.assettype,
        assetcategory: a.assetcategory,
        assetmodel: a.assetmodel,
        assetbrand: a.assetbrand,
        assetbrandmodel: a.assetbrandmodel,
        assetnetamount: a.assetnetamount,
        assetfinamount: a.assetfinamount,
        assetvariant: a.assetvariant,
        // assetclass :a.assetclass,
      });

      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });
      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      offerCriteriaList.push({
        critcode: 'FLAGUSED',
        critvalue: a.flagused ?? '',
      });

      offerCriteriaList.push({
        critcode: 'ASSETCLASS',
        critvalue: a.targetclass ?? '',
      });

      a.power != null ??
        offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });
      // additional attributes :
      a.entityAddAttributList?.forEach((e: any) => {
        e.attstringvalue !== null
          ? offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attstringvalue,
            })
          : e.attnumericvalue !== null ??
            offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attnumericvalue,
            });
      });

      if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
        a.assetusereqList?.forEach((u: any) => {
          assetUseCriteriaList.push({
            assetfamily: a.assetfamily,
            assettype: a.assettype,
            assetcategory: a.assetcategory,
            catalogid: a.catalogid ?? '',
            attcode: u.attcode ?? '',
            attvalue: u.usevalue ?? '',
          });
        });
      }
    });

    ret = {
      prcode: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
      tpid: form.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer:
        assetList && assetList.length > 0
          ? assetList![0]?.tpidmanufacturer ?? 0
          : 0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria: assetRVCriteriaList,
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };

  useEffect(() => {
    if (contract) {
      let schedule = contract?.conElements
        ?.filter((e) => e.ctetype === 'FIN')[0]
        .conElemSchedules.filter((c) => c.ciid !== null);

      let lastInvoiceDate = _.maxBy(schedule, 'ctsduedate')?.ctsduedate;

      let activeElem: any = contract?.conElements?.filter(
        (e) => e.ctetype === 'FIN' && e.ctestatus === 'PREFIN'
      );

      if (activeElem) {
        form.setFieldsValue({
          event: 'TabLoanRescheduling',
          ctFinancedAmount: activeElem[0]?.ctefinancedamount,
          newCtFinancedAmount: activeElem[0].ctefinancedamount,
          duration: activeElem[0].cteduration,
          periodicity: activeElem[0].prefinperiodicity,
          calculationtype: activeElem[0].ctecalculationtype,
          partDays: activeElem[0].ctepartdays,
          newPartDays: activeElem[0].ctepartdays,
          ratetype: activeElem[0].prefinratetype,
          rateformula: activeElem[0].prefinrateformula,
          rateref: activeElem[0].prefinrateref,
          ratespread: activeElem[0].prefinratespread,
          nominalrate: activeElem[0].prefinnominalrate,
          newDuration: activeElem[0].cteduration,
          newPeriodicity: activeElem[0].prefinperiodicity,
          newCalculationtype: activeElem[0].ctecalculationtype,
          newRatetype: activeElem[0].prefinratetype,
          newRateformula: activeElem[0].prefinrateformula,
          newRateRef: activeElem[0].prefinrateref,
          newRateSpread: activeElem[0].prefinratespread,
          newNominalRate: activeElem[0].prefinnominalrate,
          ctactivationdate: contract.ctactivationdate,
          startDate: contract.ctactivationdate,
          newStartDate: !isNil(contract.ctactivationdate)
            ? toDatePickerDate(contract.ctactivationdate)
            : moment(new Date(), 'YYYY-MM-DD'),
          lastInvoiceDate: lastInvoiceDate,
          effectDate: !isNil(lastInvoiceDate)
            ? toDatePickerDate(lastInvoiceDate)
            : moment(new Date(), 'YYYY-MM-DD'),
          assets: contract.assets ?? [],
          oldOfferId: contract?.offer?.offerid,
          flagamortizevat: false,
        });
        setSelectedClass('');
      }
    }
  }, [contract]);

  const reset = () => {
    if (contract) {
      let schedule = contract?.conElements
        ?.filter((e) => e.ctetype === 'FIN')[0]
        .conElemSchedules.filter((c) => c.ciid !== null);

      let lastInvoiceDate = _.maxBy(schedule, 'ctsduedate')?.ctsduedate;

      let activeElem: any = contract?.conElements?.filter(
        (e) => e.ctetype === 'FIN' && e.ctestatus === 'PREFIN'
      );

      if (activeElem) {
        form.setFieldsValue({
          event: 'TabLoanRescheduling',
          ctFinancedAmount: activeElem[0]?.ctefinancedamount,
          newCtFinancedAmount: activeElem[0].ctefinancedamount,
          duration: activeElem[0].cteduration,
          periodicity: activeElem[0].prefinperiodicity,
          calculationtype: activeElem[0].ctecalculationtype,
          partDays: activeElem[0].ctepartdays,
          newPartDays: activeElem[0].ctepartdays,
          ratetype: activeElem[0].prefinratetype,
          rateformula: activeElem[0].prefinrateformula,
          rateref: activeElem[0].prefinrateref,
          ratespread: activeElem[0].prefinratespread,
          nominalrate: activeElem[0].prefinnominalrate,
          newDuration: activeElem[0].cteduration,
          newPeriodicity: activeElem[0].prefinperiodicity,
          newCalculationtype: activeElem[0].ctecalculationtype,
          newRatetype: activeElem[0].prefinratetype,
          newRateformula: activeElem[0].prefinrateformula,
          newRateRef: activeElem[0].prefinrateref,
          newRateSpread: activeElem[0].prefinratespread,
          newNominalRate: activeElem[0].prefinnominalrate,
          ctactivationdate: contract.ctactivationdate,
          startDate: contract.ctactivationdate,
          newStartDate: !isNil(contract.ctactivationdate)
            ? toDatePickerDate(contract.ctactivationdate)
            : moment(new Date(), 'YYYY-MM-DD'),
          lastInvoiceDate: lastInvoiceDate,
          effectDate: !isNil(lastInvoiceDate)
            ? toDatePickerDate(lastInvoiceDate)
            : moment(new Date(), 'YYYY-MM-DD'),
          assets: contract.assets ?? [],
          oldOfferId: contract?.offer?.offerid,
          flagamortizevat: false,
        });
        setSelectedClass('');
      }
    }
  };

  const calculateFees = (pricing?: PricingResponse) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: contract?.conElements[0].conElemSchedules ?? [],
          inDownPayment: 0,
          inFinAmount: contract?.conElements[0].ctefinancedamount ?? 0,
          inFollowGP: true,
          inGPDuration: contract?.conElements[0].ctegraceperiodduration ?? 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: 20,
          inDuration: contract?.conElements[0].cteduration ?? 0,
          inInvestAmount: contract?.conElements[0].cteinvestamount ?? 0,
          inAssetAmount: contract?.assets[0].assetnetamount ?? 0,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: dateToString(form?.getFieldValue('effectDate')),
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          form?.setFieldsValue({
            feesAmount: res.installmentamount,
            feesFormula: pricing?.priid,
          });
        }
      });
  };

  const getName = useCallback(
    (name: string) => (record: any) => {
      const assets = form.getFieldValue('assets');
      const index = indexBy(assets, 'assetid')[record.assetid];
      return [fieldname, index, name];
    },
    [form]
  );

  const columns = useMemo<DataGridColDef<FinAssetResponse>[]>(
    () => [
      {
        dataIndex: 'assetid',
        width: 200,
      },
      {
        dataIndex: 'assetreference',
        width: 200,
      },
      {
        dataIndex: 'assetlabel',
        width: 200,
      },
      {
        dataIndex: 'assetnetamount',
        width: 200,
      },
      {
        dataIndex: 'assetrvamount',
        width: 200,
      },
      {
        dataIndex: 'finrvamount',
        width: 200,
      },
      {
        dataIndex: 'targetclass',
        width: 200,
        render: (value, record) =>
          mode === 'REAL' ? (
            <ParListSelect
              parcode="ASSETCLASS"
              value={selectedClass}
              style={{ width: '100%' }}
              disabled
            />
          ) : (
            <Form.Item
              noStyle
              name={getName('targetclass')(record)}
              initialValue={selectedClass}
            >
              <ParListSelect
                onChange={(e) => {
                  setSelectedClass(e);
                }}
                parcode="ASSETCLASS"
                value={selectedClass}
                style={{ width: '100%' }}
                disabled={mode === 'REAL'}
              />
            </Form.Item>
          ),
      },
    ],
    [selectedClass]
  );

  return (
    <DF.Provider
      pagcode="TabLoanRescheduling"
      entity={object}
      entityid={objectid}
    >
      <Spin spinning={isFetching || isLoading}>
        <Form
          form={form}
          layout="horizontal"
          labelAlign="left"
          wrapperCol={{ span: 15 }}
          labelCol={{ span: 9 }}
        >
          <UtinaCard comcode="TabLoanRescheduling" level={5}>
            <Row gutter={10}>
              <FormInput
                col
                md={7}
                name="mode"
                rules={[{ required: true }]}
                initialValue={mode}
                labelCol={{ span: 6 }}
              >
                <div className="radio-group">
                  <span
                    className={
                      mode === 'SIMUL'
                        ? 'radio-button radio-button-checked'
                        : 'radio-button'
                    }
                    onClick={() => {
                      setMode('SIMUL');
                      reset();
                      form.setFieldsValue({ modid: undefined, mode: 'SIMUL' });
                    }}
                  >
                    SIMUL
                  </span>
                  <span
                    className={
                      mode === 'REAL'
                        ? 'radio-button radio-button-checked'
                        : 'radio-button'
                    }
                    onClick={() => {
                      setMode('REAL');
                      form.setFieldValue('mode', 'REAL');
                    }}
                  >
                    REAL
                  </span>
                </div>
              </FormInput>

              {/* <Col md={5}>
                <div className="radio-group">
                  <span
                    className={
                      mode === 'SIMUL'
                        ? 'radio-button radio-button-checked'
                        : 'radio-button'
                    }
                    onClick={() => {
                      setMode('SIMUL');
                    }}
                  >
                    SIMUL
                  </span>
                  <span
                    className={
                      mode === 'REAL'
                        ? 'radio-button radio-button-checked'
                        : 'radio-button'
                    }
                    onClick={() => {
                      setMode('REAL');
                    }}
                  >
                    REAL
                  </span>
                </div>
              </Col> */}

              {mode === 'REAL' && (
                <FormInput
                  col
                  md={10}
                  name="modid"
                  labelAlign="left"
                  rules={[{ required: mode === 'REAL' }]}
                  labelCol={{ span: 7 }}
                  wrapperCol={{ span: 15 }}
                >
                  <Select
                    allowClear
                    style={{ width: '100%' }}
                    onSelect={handleFinModSelect}
                    onClear={() => {
                      reset();
                    }}
                  >
                    {modList?.map((e: any, index: number) => (
                      <Select.Option key={index} value={e.modid}>
                        {e.ctreference + ' - ' + e.modid + ' - ' + e.modcomment}
                      </Select.Option>
                    ))}
                  </Select>
                </FormInput>
              )}
            </Row>
            <Divider />
            <Row gutter={10}>
              <FormInput col md={6} name="ctactivationdate">
                <Value />
              </FormInput>

              <FormInput col md={6} name="lastInvoiceDate">
                <Value />
              </FormInput>

              <Col
                span={8}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Tag color="magenta" style={{ borderRadius: 5 }}>
                  <FormInput
                    name="effectDate"
                    noMargin
                    rules={[{ required: true }]}
                  >
                    <DatePicker
                      disabled={mode === 'REAL'}
                      size="middle"
                      //   onChange={(e) => calculatePreFin(e)}
                      //disabledDate={disableDaysBeforeToday}
                    />
                  </FormInput>
                </Tag>
              </Col>
            </Row>
          </UtinaCard>
          <Row>
            <UtinaCard
              level={5}
              comcode="Assets"
              styleCard={{
                color: '#000',
                paddingTop: 20,
                paddingBottom: 25,
              }}
              lg={23}
            >
              <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  const assets: any[] = getFieldValue('assets');

                  return (
                    <DataGrid
                      columns={columns}
                      dataSource={assets ?? []}
                      rowKey={(e: any) => e.ctrid}
                      hideFilters
                      hideTitle
                    />
                  );
                }}
              </Form.Item>
              <Row>
                <FormInput col md={6} name="flagamortizevat" shouldUpdate>
                  <Checkbox
                    onChange={(a) => {
                      let assets = form.getFieldValue('assets');
                      let netamount = sumBy(assets, 'assetnetamount');
                      let grossamount = sumBy(assets, 'assetfinamount');

                      form.setFieldValue('flagamortizevat', a.target.checked);

                      if (a.target.checked) {
                        form.setFieldValue(
                          'assettaxamount',
                          grossamount - netamount
                        );
                        form.setFieldValue('newCtFinancedAmount', netamount);
                      } else {
                        form.setFieldValue('assettaxamount', 0);
                        form.setFieldValue('newCtFinancedAmount', grossamount);
                      }
                    }}
                    checked={form.getFieldValue('flagamortizevat')}
                  />
                </FormInput>
                <FormInput col md={6} name="assettaxamount" shouldUpdate>
                  <Value formatter={(val) => toCurrency(val)} />
                </FormInput>
                <FormInput col md={6} name="flaggenpayment">
                  <Checkbox />
                </FormInput>
              </Row>
            </UtinaCard>
          </Row>

          <Row gutter={20}>
            <UtinaCard
              level={5}
              comcode="currentSituation"
              styleCard={{
                color: '#000',
                paddingTop: 20,
                paddingBottom: 25,
              }}
              lg={11}
            >
              <Row>
                <FormInput col md={17} name="ctFinancedAmount">
                  <Value />
                </FormInput>
                <FormInput col md={17} name="startDate">
                  <Value />
                </FormInput>
                <FormInput col md={17} name="partDays" comcode="partDays">
                  <Value />
                </FormInput>
                <FormInput col md={17} name="duration">
                  <Value />
                </FormInput>

                <FormInput col md={17} name="periodicity" comcode="periodicity">
                  <ParListSelect parcode="PREFINPER" disabled />
                </FormInput>
                <FormInput col md={17} name="endDate">
                  <Value />
                </FormInput>

                <FormInput col md={17} name="calculationtype">
                  <ParListSelect parcode="CALMETHOD" disabled />
                </FormInput>
                <FormInput col md={17} name="ratetype" comcode="ratetype">
                  <ParListSelect parcode="RATETYPE" disabled />
                </FormInput>
                <FormInput col md={17} name="rateformula" comcode="rateformula">
                  <RateFormulaSelect
                    params={{
                      formulatype: form.getFieldValue('ratetype'),
                    }}
                    disabled
                  />
                </FormInput>
                <FormInput col md={17} name="rateref" comcode="rateref">
                  <Value formatter={toRate} />
                </FormInput>
                <FormInput col md={17} name="ratespread" comcode="ratespread">
                  <Value formatter={toRate} />
                </FormInput>
                <FormInput col md={17} name="nominalrate" comcode="nominalrate">
                  <Value formatter={toRate} />
                </FormInput>

                <FormInput col xs={24} md={17} name="oldOfferId">
                  <OfferInput
                    params={{
                      prcode: contract?.prcode ?? '',
                      filtersList: getFilterList(),
                      filters: '',
                      finamount: form.getFieldValue('newCtFinancedAmount'),
                      duration: form.getFieldValue('newDuration'),
                      searchMode: 'PRCODE',
                    }}
                    disabled
                  />
                </FormInput>
              </Row>
            </UtinaCard>

            <UtinaCard
              level={5}
              comcode="requestedModifications"
              styleCard={{
                color: '#000',
                paddingTop: 20,
                paddingBottom: 25,
              }}
              lg={12}
            >
              <Row>
                <FormInput col md={17} name="newCtFinancedAmount">
                  <InputCurrency currcode="EUR" disabled={mode === 'REAL'} />
                </FormInput>
                <FormInput col md={17} name="startDate">
                  <Value />
                </FormInput>
                <FormInput col md={17} name="newPartDays">
                  <InputNumber disabled={mode === 'REAL'} />
                </FormInput>

                <FormInput col md={17} name="newDuration">
                  <InputNumber
                    disabled={mode === 'REAL'}
                    onChange={(e: any) => {
                      let startdate =
                        form.getFieldValue('newStartDate') ?? moment();
                      var init = moment(dateToString(startdate));
                      var target = init
                        .add(form.getFieldValue('newDuration'), 'M')
                        .subtract(1, 'd');
                      form.setFieldsValue({
                        newEndDate: dateToString(target),
                      });
                    }}
                  />
                </FormInput>

                <FormInput col md={17} name="newPeriodicity">
                  <ParListSelect
                    parcode="PREFINPER"
                    disabled={mode === 'REAL'}
                  />
                </FormInput>
                <FormInput col md={17} name="newEndDate">
                  <Value />
                </FormInput>

                <FormInput col md={17} name="newCalculationtype">
                  <ParListSelect parcode="CALMETHOD" disabled />
                </FormInput>
                <FormInput col md={17} name="newRatetype">
                  <ParListSelect
                    parcode="RATETYPE"
                    disabled={mode === 'REAL'}
                  />
                </FormInput>
                <FormInput col md={17} name="newRateformula">
                  <RateFormulaSelect
                    params={{
                      formulatype: form.getFieldValue('newRatetype'),
                    }}
                    disabled={mode === 'REAL'}
                  />
                </FormInput>
                <FormInput col md={17} name="newRateRef" comcode="rateref">
                  <InputRate
                    disabled={mode === 'REAL'}
                    onChange={(e) => {
                      form.setFieldValue(
                        'newNominalRate',
                        e + form.getFieldValue('newRateSpread')
                      );
                    }}
                  />
                </FormInput>
                <FormInput col md={17} name="newRateSpread" shouldUpdate>
                  <InputRate
                    disabled={mode === 'REAL'}
                    onChange={(e) => {
                      form.setFieldValue(
                        'newNominalRate',
                        e + form.getFieldValue('newRateRef')
                      );
                    }}
                  />
                </FormInput>
                <FormInput col md={17} name="newNominalRate">
                  <InputRate disabled={mode === 'REAL'} />
                </FormInput>

                <FormInput col xs={24} md={17} name="offerid">
                  <OfferInput
                    params={{
                      prcode: contract?.prcode ?? '',
                      filtersList: getFilterList(),
                      filters: '',
                      finamount: form.getFieldValue('newCtFinancedAmount'),
                      duration: form.getFieldValue('newDuration'),
                      searchMode: 'PRCODE',
                    }}
                    disabled={selectedClass === '' || mode === 'REAL'}
                    onChange={(offerid) => {
                      getprOfferDetailByOfferId({
                        offerid: offerid,
                        filtersList: getFilterList(),
                      }).then((res: any) => {
                        if (res.data != null) {
                          try {
                            let startdate =
                              form.getFieldValue('newStartDate') ?? moment();
                            var init = moment(dateToString(startdate));
                            var target = init
                              .add(form.getFieldValue('newDuration'), 'M')
                              .subtract(1, 'd');
                            form.setFieldsValue({
                              newEndDate: dateToString(target),
                            });
                          } catch (error) {
                          }

                          form.setFieldsValue({
                            newDuration: res.data.durationdefault,
                            newPeriodicity: res.data.prefinperiodicity,
                            newCalculationtype: res.data.prefinmethod,
                            newRatetype: res.data.prefinratetype,
                            newRateformula: res.data.prefinrateformula,
                            newRateRef: res.data.prefinrateref,
                            newRateSpread: res.data.prefinratespreaddefault,
                            newNominalRate: res.data.prefinnominalrate,
                          });
                        }
                      });
                    }}
                  />
                </FormInput>
              </Row>
            </UtinaCard>
          </Row>
          <Row gutter={20}>
            <UtinaCard
              level={5}
              comcode="FeesFormula"
              styleCard={{
                color: '#000',
                paddingTop: 20,
                paddingBottom: 25,
              }}
              lg={6}
            >
              <Row>
                <FormInput
                  col
                  xs={24}
                  name="feesFormula"
                  //rules={[{ required: true }]}
                >
                  <PricingListFilteredSelect
                    //disabled={!getFieldValue('offerid')}
                    allowClear
                    params={{
                      offerid: contract?.offerid ?? 0,
                      ctetype: 'MODFEES', // Modifictaion fees
                      prcode: contract?.prcode ?? '',
                      entity: '',
                      entityid: 0,
                      tpid: contract?.tpidclient ?? 0,
                    }}
                    onClear={() => {
                      form?.setFieldValue('feesAmount', 0);
                    }}
                    onChange={(e) => calculateFees(e)}
                    disabled={mode === 'REAL'}
                  />
                </FormInput>
              </Row>
              <Row>
                <FormInput col xs={24} name="feesAmount" shouldUpdate>
                  <InputCurrency
                    currcode={
                      contract?.currcode ??
                      localStorage.getItem('currcode') ??
                      ''
                    }
                    defaultValue={0}
                    disabled={mode === 'REAL'}
                  />
                </FormInput>
              </Row>
            </UtinaCard>

            <UtinaCard
              level={5}
              comcode="reason&&comment"
              styleCard={{
                color: '#000',
                paddingTop: 20,
                paddingBottom: 25,
              }}
              lg={17}
            >
              <Row gutter={30}>
                <FormInput col md={10} name="modreason">
                  <ParListSelect
                    disabled={mode === 'REAL'}
                    parcode="LPREIMREAS"
                  />
                </FormInput>

                <FormInput col md={12} name="flagUpdateAuthorization">
                  <Checkbox />
                </FormInput>
                <FormInput col md={20} labelCol={{ span: 4 }} name="comment">
                  <TextArea rows={3} />
                </FormInput>
              </Row>
            </UtinaCard>
          </Row>
        </Form>
      </Spin>
    </DF.Provider>
  );
};

export default TabLoanRescheduling;
